import React from "react";
import {
  ShieldCheck, Users, BadgeIndianRupee, Clock, Map, Headphones,
} from "lucide-react";
import { WHY_US, GALLERY } from "../lib/site";

const ICONS = { ShieldCheck, Users, BadgeIndianRupee, Clock, Map, Headphones };

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-16 md:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <div className="grid grid-cols-2 gap-4">
            <img src={GALLERY[0]} alt="Movers packing" className="rounded-2xl shadow-md object-cover h-44 sm:h-56 w-full" />
            <img src={GALLERY[3]} alt="Loading truck" className="rounded-2xl shadow-md object-cover h-44 sm:h-56 w-full mt-8" />
            <img src={GALLERY[1]} alt="Furniture relocation" className="rounded-2xl shadow-md object-cover h-44 sm:h-56 w-full -mt-4" />
            <img src={GALLERY[4]} alt="Office shifting" className="rounded-2xl shadow-md object-cover h-44 sm:h-56 w-full" />
          </div>
          <div className="hidden md:flex absolute -bottom-6 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-xl px-5 py-3 items-center gap-3 border border-slate-200">
            <div className="w-10 h-10 rounded-full bg-orange-100 grid place-items-center">
              <ShieldCheck className="text-orange-600" size={20} />
            </div>
            <div>
              <div className="text-sm font-bold text-slate-900">Trusted by 1000+ Families</div>
              <div className="text-xs text-slate-500">Across Delhi NCR</div>
            </div>
          </div>
        </div>

        <div>
          <span className="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-xs font-bold uppercase tracking-wider">
            About Us
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>
            Aapka <span className="text-orange-600">Bharosa</span>, Hamari{" "}
            <span className="text-blue-800">Zimmedari</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            <strong className="text-slate-800">A SEVEN PACKERS AND MOVERS</strong> Delhi NCR ki ek
            trusted shifting company hai. Hum home shifting, office relocation, loading-unloading
            aur packing-unpacking ka complete solution dete hain. Kaam dekh kar aapko honest aur
            reasonable price dete hain — koi hidden charges nahi.
          </p>
          <p className="mt-3 text-slate-600 leading-relaxed">
            Hamari trained team aur professional moving trucks aapke saamaan ki safety ka pura
            khayal rakhte hain. Delhi NCR me kahin bhi shifting karwani ho — hum ready hain 24/7.
          </p>

          <div id="why-us" className="mt-8 grid grid-cols-2 gap-3">
            {WHY_US.map((w, idx) => {
              const Icon = ICONS[w.icon] || ShieldCheck;
              return (
                <div
                  key={w.title}
                  data-testid={`why-us-${idx}`}
                  className="flex items-start gap-3 bg-white rounded-xl border border-slate-200 p-3.5 hover:border-orange-300 transition"
                >
                  <div className="w-10 h-10 shrink-0 rounded-lg bg-gradient-to-br from-blue-50 to-orange-50 grid place-items-center">
                    <Icon className="text-blue-800" size={18} />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-slate-900">{w.title}</div>
                    <div className="text-xs text-slate-500 mt-0.5">{w.desc}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
